import DataRoomSignerNdaStatus from './DataRoomSignerNdaStatus.component';

export default DataRoomSignerNdaStatus;